import * as React from 'react';

import { CallButton } from './CallButton';
import { trackShowPhone, trackOpenContacts } from './tracking';

export interface IHeaderCallProps {
  placeType?: string;
  eventAction: string;
}

export const HeaderCall: React.FC<IHeaderCallProps> = ({ placeType = 'blockReviewsStickyHeader', eventAction }) => {
  const onShowPhoneClick = React.useCallback(() => {
    trackShowPhone('', eventAction);
  }, [eventAction]);

  const onOpenContactsClick = React.useCallback(() => {
    trackOpenContacts('');
  }, []);

  return (
    <CallButton placeType={placeType} onShowPhoneClick={onShowPhoneClick} onOpenContactsClick={onOpenContactsClick} />
  );
};
